import { render, staticRenderFns } from "./TweetModal.vue?vue&type=template&id=5b46823d&scoped=true&"
import script from "./TweetModal.vue?vue&type=script&lang=js&"
export * from "./TweetModal.vue?vue&type=script&lang=js&"
import style0 from "./TweetModal.vue?vue&type=style&index=0&id=5b46823d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46823d",
  null
  
)

export default component.exports